import React from "react";
import { Link } from "@remix-run/react";
import GlobalContactWhatsappFloating from "./GlobalContactWhatsappFloating";

type GlobalSeoDescriptionContentProps = {
  slug: string;
  district: string;
  currentPage: string;
  baseSlug?: string; // opsional
};

const titleCase = (slug: string): string => {
  return slug
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const GlobalSeoDescriptionContent: React.FC<
  GlobalSeoDescriptionContentProps
> = ({ slug, district, currentPage, baseSlug }) => {
  const pageTitle = titleCase(slug);
  const districtLower = district.toLowerCase();

  return (
    <section className="prose prose-lg max-w-none">
      <h2 className="text-2xl py-[2rem] font-bold">
        <Link
          to={`https://arsinesia.com/${baseSlug ? `${baseSlug}` : ""}`}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
        >
          {pageTitle}
        </Link>
      </h2>

      <h3 className="text-lg pb-[1rem] font-bold">
        Mengapa renovasi rumah di {districtLower} bekasi adalah Pilihan Tepat?
      </h3>
      <p>
        <Link
          to={`https://arsinesia.com/${baseSlug ? `${baseSlug}` : ""}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:underline"
        >
          {pageTitle}
        </Link>{" "}
        menawarkan solusi tepat untuk kebutuhan Anda dalam membangun atau
        merenovasi rumah di {districtLower} Bekasi. Dengan dukungan tim
        profesional dan pengalaman bertahun-tahun, kami memastikan kualitas
        terbaik dan hasil yang memuaskan.
      </p>

      <h2>Keunggulan Layanan Renovasi Rumah di {districtLower} Bekasi</h2>
      <ul className="py-[1rem] list-disc pl-5 space-y-2 text-gray-700">
        <li>Desain yang disesuaikan dengan kebutuhan Anda</li>
        <li>Material berkualitas tinggi</li>
        <li>Tim ahli dengan pengalaman luas</li>
        <li>Waktu pengerjaan sesuai kesepakatan</li>
      </ul>

      <h3 className="text-lg  font-semibold">
        Proses Renovasi di {districtLower} yang Transparan
      </h3>
      <p className="py-[1rem]">
        Kami memastikan setiap langkah dalam proses renovasi di {districtLower}{" "}
        dilakukan secara transparan, mulai dari konsultasi awal, perencanaan,
        hingga pelaksanaan dan serah terima bangunan. Kepuasan Anda adalah
        prioritas kami.
      </p>

      <h3 className="text-lg pb-[1rem] font-semibold">
        Hubungi Kami untuk Konsultasi Gratis
      </h3>
      <p>
        Tertarik dengan layanan {pageTitle}? Hubungi kami sekarang untuk
        mendapatkan penawaran dan konsultasi gratis. Mari wujudkan hunian impian
        Anda di {districtLower} bersama kami.
      </p>
      <div className="w-fit pt-[1rem] pb-[2rem]">
        <GlobalContactWhatsappFloating
          buttonText="Konsultasi Gratis"
          currentPage={currentPage}
        />
      </div>
    </section>
  );
};

export default GlobalSeoDescriptionContent;
